module.exports = __webpack_public_path__ + "static/img/video-pass-off.09a0c8a2.png";